import DatasetFilterWidget from './dataset-filter-widget-model'
import _ from 'lodash'
import createWob from '../create-wob'
import buildDatasetFieldSelectorMenu from 'scoreboard/components/bootslide/build-dataset-field-selector-menu'
import { defaultOption } from 'scoreboard/datasets/filters/operator-options'
import nextLinkGroup from 'scoreboard/datasets/filters/next-link-group'
import currentPeriodDatasetFilter from '../current-period-dataset-filter'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE, DATE_TIME } = DataType
import Dataset from 'scoreboard/datasets/model/dataset'
const { isTotal } = Dataset

var DatasetFilterWidgetAddMenu = function (bootslideMenu) {
	return buildDatasetFieldSelectorMenu({
		menuLabel: 'dashboards.datasets.filter',
		iconId: 'add-widget-dataset-filter',
		bootslideMenu,
		fieldSelectorTargetId: 'dataset-filter-field',
		fieldSelectorOptions: {
			allowEditFields: true,
			// #55804 we don't support filtering on total fields until #55806 is
			// implemented
			fieldListFilter: field => !isTotal(field.id)
		},
		onFieldSelect: selected => addFilterWidget({ bootslideMenu, selected })
	})
}

function addFilterWidget ({ bootslideMenu, selected }) {
	let underlyingField = selected.dataset.getUnderlyingField(selected.field.id)
	let operator = defaultOption(underlyingField, { parentDomainType: 'dashboard' })

	let filter
	if (_.includes([DATE, DATE_TIME], underlyingField.dataType)) {
		// #26622 set new date filters to "current period"
		filter = currentPeriodDatasetFilter(selected)
	} else {
		filter = {
			fieldId: selected.fieldId,
			visibleLinkedFieldId: selected.visibleLinkedFieldId,
			operator: operator
		}
	}

	// #36002 make sure the new filter widget's linkGroup is unique, so it isn't
	// accidentally added to the linkGroup of an existing filter widget
	let filterWidgetFilters = bootslideMenu.canvas.collection.toArray()
		.filter(wob => wob.widget.properties.get('type') === 'dataset-filter')
		.map(wob => JSON.parse(wob.widget.properties.get('filter')))

	filter.linkGroup = nextLinkGroup(filterWidgetFilters)

	// Make sure dataset is in dashboard-level data
	let dataset = selected.dataset.toJSON()
	bootslideMenu.model.data.datasets(dataset.id, dataset)

	var widget = new DatasetFilterWidget(
		{
			properties: {
				type: 'dataset-filter',
				datasetId: selected.dataset.id,
				filter: JSON.stringify(filter),
				showFilterType: false
			}
		}, {
			domainObject: dataset
		})

	// no need to do a data fetch, because we already have the dataset and passed it in
	// to the widget model (via the domainObject option)
	createWob(bootslideMenu.canvas, widget, { fetchData: false }, bootslideMenu)
}
export default DatasetFilterWidgetAddMenu

DatasetFilterWidgetAddMenu.__filename__ = 'dashboards/widgets/dataset-filter/dataset-filter-widget-add-menu.js'
